import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aaa8685"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "欢迎", -1))
const _hoisted_2 = { class: "welcome" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_the_welcome = _resolveComponent("the-welcome")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        width: "200",
        style: {"background":"#fff"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "inline",
            style: { height: '100%', borderRight: 0 },
            onClick: _ctx.handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, { key: "welcome" }, {
                default: _withCtx(() => [
                  _createVNode(_component_MailOutlined),
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.level1, (item) => {
                return (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: item.id
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_user_outlined),
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: child.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MailOutlined),
                          _createElementVNode("span", null, _toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(_component_the_welcome)
          ], 512), [
            [_vShow, _ctx.isShowWelcome]
          ]),
          _withDirectives(_createVNode(_component_a_list, {
            "item-layout": "vertical",
            size: "large",
            grid: { gutter:20,column:3},
            pagination: _ctx.pagination,
            "data-source": _ctx.ebooks
          }, {
            renderItem: _withCtx(({ item }) => [
              _createVNode(_component_a_list_item, { key: "item.name" }, {
                actions: _withCtx(() => [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent('LikeOutlined'), { style: {"margin-right":"8px"} })),
                    _createTextVNode(" " + _toDisplayString(item.voteCount), 1)
                  ]),
                  _createElementVNode("span", null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent('UserOutlined'), { style: {"margin-right":"8px"} })),
                    _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                  ]),
                  _createElementVNode("span", null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent('FileOutlined'), { style: {"margin-right":"8px"} })),
                    _createTextVNode(" " + _toDisplayString(item.docCount), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_list_item_meta, {
                    description: item.description
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: '/doc?ebookId='+item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    avatar: _withCtx(() => [
                      _createVNode(_component_a_avatar, {
                        src: item.cover
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1032, ["description"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["pagination", "data-source"]), [
            [_vShow, !_ctx.isShowWelcome]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}